import React from 'react';
import { bool, shape, string } from 'prop-types';

const ChevronRightColor = ({
  className = 'icon',
  notUseClass = false,
  color = '#696f88',
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={{ color, ...style }} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.2207 12.4425L9.6557 9L6.2207 5.5575L7.2782 4.5L11.7782 9L7.2782 13.5L6.2207 12.4425Z" fill="currentColor" />
  </svg>
);

ChevronRightColor.propTypes = {
  className: string,
  notUseClass: bool,
  color: string,
  style: shape({}),
};

export default ChevronRightColor;
